var moment = require('moment');

var dateFormat = 'MM/DD/YYYY';

function parseCalibrationDue(value) {
  var dueDate;

  if (value === null || typeof value === 'undefined') {
    return null;
  }

  if (typeof value === 'string') {
    value = value.trim();
    if (!value || value.toLowerCase() === 'pending') {
      return null;
    }
    dueDate = /^-?\d+(\.\d+)?$/.test(value)
      ? moment(Number(value))
      : moment(value, moment.ISO_8601, true);
  } else {
    dueDate = moment(value);
  }

  return dueDate.isValid() ? dueDate : null;
}

function isCalibrationDueActive(value, now) {
  var dueDate = parseCalibrationDue(value);
  if (!dueDate) return false;

  return (now ? moment(now) : moment()).startOf('day').valueOf() <= dueDate.valueOf();
}

function buildCertifiedInstrumentOption(instrument, now) {
  var dueDate = parseCalibrationDue(instrument && instrument.calibrationDue);
  var active = dueDate && isCalibrationDueActive(instrument.calibrationDue, now);
  var name = instrument && instrument.name ? instrument.name : 'Certified Instrument';
  var label = dueDate ?
    name + ' (Valid until ' + dueDate.format(dateFormat) + ')' :
    name + ' (Pending)';

  return {
    value: instrument && instrument['@rid'],
    label: label,
    disabled: !active
  };
}

function getValidCertifiedInstrument(instruments, rid, now) {
  if (!rid || !Array.isArray(instruments)) return null;

  return instruments.find(function (instrument) {
    return instrument && instrument['@rid'] === rid && isCalibrationDueActive(instrument.calibrationDue, now);
  }) || null;
}

module.exports = {
  buildCertifiedInstrumentOption: buildCertifiedInstrumentOption,
  getValidCertifiedInstrument: getValidCertifiedInstrument,
  isCalibrationDueActive: isCalibrationDueActive,
  parseCalibrationDue: parseCalibrationDue
};
